
export default {
  name: "PostIndex",

  async asyncData({ $content }) {
    const posts = await $content("posts")
      .only([
        "title",
        "path",
        "previewImage",
        "previewImageAlt",
        "createdAt",
        "description",
      ])
      .sortBy("createdAt", "desc")
      .fetch();
    return { posts };
  },

  head() {
    const title = "News";
    const description = "Latest news from Port Perry Pedals";

    return {
      title,
      meta: this.$generateMetaTags({ title, description }),
    };
  },
};
